import { render, staticRenderFns } from "./BadgeDetail.vue?vue&type=template&id=44a4b3f0&scoped=true&"
import script from "./BadgeDetail.vue?vue&type=script&lang=js&"
export * from "./BadgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDetail.vue?vue&type=style&index=0&id=44a4b3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a4b3f0",
  null
  
)

export default component.exports